{
  "AF": "Afeganistão",
  "ZA": "África do Sul",
  "AL": "Albânia",
  "DZ": "Argélia",
  "DE": "Alemanha",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antártida",
  "AG": "Antígua e Barbuda",
  "SA": "Arábia Saudita",
  "AR": "Argentina",
  "AM": "Armênia",
  "AW": "Aruba",
  "AU": "Austrália",
  "AT": "Áustria",
  "AZ": "Azerbaijão",
  "BS": "Bahamas",
  "BH": "Bahrein",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BE": "Bélgica",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermudas",
  "BT": "Butão",
  "BY": "Bielorrússia",
  "BO": "Bolívia",
  "BA": "Bósnia e Herzegovina",
  "BW": "Botswana",
  "BR": "Brasil",
  "BN": "Brunei",
  "BG": "Bulgária",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "KH": "Camboja",
  "CM": "Camarões",
  "CA": "Canadá",
  "CV": "Cabo Verde",
  "EA": "Ceuta e Melilla",
  "CL": "Chile",
  "CN": "China",
  "CY": "Chipre",
  "CO": "Colômbia",
  "KM": "Comores",
  "CG": "Congo-Brazzaville",
  "CD": "Congo-Kinshasa",
  "KP": "Coreia do Norte",
  "KR": "Coreia do Sul",
  "CR": "Costa Rica",
  "CI": "Costa do Marfim",
  "HR": "Croácia",
  "CU": "Cuba",
  "CW": "Curaçao",
  "DK": "Dinamarca",
  "DG": "Diego Garcia",
  "DJ": "Djibuti",
  "DM": "Dominica",
  "EG": "Egito",
  "SV": "El Salvador",
  "AE": "Emirados Árabes Unidos",
  "EC": "Equador",
  "ER": "Eritreia",
  "ES": "Espanha",
  "EE": "Estônia",
  "VA": "Vaticano",
  "FM": "Micronésia",
  "US": "Estados Unidos",
  "ET": "Etiópia",
  "EZ": "Eurozona",
  "FJ": "Fiji",
  "FI": "Finlândia",
  "FR": "França",
  "GA": "Gabão",
  "GM": "Gâmbia",
  "GE": "Geórgia",
  "GS": "Geórgia do Sul e Ilhas Sandwich do Sul",
  "GH": "Gana",
  "GI": "Gibraltar",
  "GR": "Grécia",
  "GD": "Granada",
  "GL": "Groenlândia",
  "GP": "Guadalupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guiné",
  "GQ": "Guiné Equatorial",
  "GW": "Guiné-Bissau",
  "GY": "Guiana",
  "GF": "Guiana Francesa",
  "HT": "Haiti",
  "HN": "Honduras",
  "HU": "Hungria",
  "CX": "Ilha Christmas",
  "AC": "Ilha da Ascensão",
  "IM": "Ilha de Man",
  "NF": "Ilha Norfolk",
  "AX": "Ilhas Åland",
  "KY": "Ilhas Cayman",
  "IC": "Ilhas Canárias",
  "CC": "Ilhas Cocos",
  "CK": "Ilhas Cook",
  "FO": "Ilhas Feroé",
  "FK": "Ilhas Malvinas",
  "MP": "Ilhas Marianas do Norte",
  "MH": "Ilhas Marshall",
  "UM": "Ilhas Menores Distantes dos Estados Unidos",
  "PN": "Ilhas Pitcairn",
  "SB": "Ilhas Salomão",
  "TC": "Ilhas Turcas e Caicos",
  "VG": "Ilhas Virgens Britânicas",
  "VI": "Ilhas Virgens dos EUA",
  "IN": "Índia",
  "ID": "Indonésia",
  "IQ": "Iraque",
  "IR": "Irã",
  "IE": "Irlanda",
  "IS": "Islândia",
  "IL": "Israel",
  "IT": "Itália",
  "JM": "Jamaica",
  "JP": "Japão",
  "JE": "Jersey",
  "JO": "Jordânia",
  "KZ": "Cazaquistão",
  "KE": "Quênia",
  "KG": "Quirguistão",
  "KI": "Kiribati",
  "XK": "Kosovo",
  "KW": "Kuwait",
  "RE": "Reunião",
  "LA": "Laos",
  "LS": "Lesoto",
  "LV": "Letônia",
  "LB": "Líbano",
  "LR": "Libéria",
  "LY": "Líbia",
  "LI": "Liechtenstein",
  "LT": "Lituânia",
  "LU": "Luxemburgo",
  "MK": "Macedônia do Norte",
  "MG": "Madagascar",
  "MY": "Malásia",
  "MW": "Malawi",
  "MV": "Maldivas",
  "ML": "Mali",
  "MT": "Malta",
  "MA": "Marrocos",
  "MQ": "Martinica",
  "MU": "Maurício",
  "MR": "Mauritânia",
  "YT": "Mayotte",
  "MX": "México",
  "MD": "Moldávia",
  "MC": "Mônaco",
  "MN": "Mongólia",
  "ME": "Montenegro",
  "MS": "Montserrat",
  "MZ": "Moçambique",
  "MM": "Mianmar (Birmânia)",
  "NA": "Namíbia",
  "UN": "Nações Unidas",
  "NR": "Nauru",
  "NP": "Nepal",
  "NI": "Nicarágua",
  "NE": "Níger",
  "NG": "Nigéria",
  "NU": "Niue",
  "NO": "Noruega",
  "NC": "Nova Caledônia",
  "NZ": "Nova Zelândia",
  "OM": "Omã",
  "UG": "Uganda",
  "UZ": "Uzbequistão",
  "PK": "Paquistão",
  "PW": "Palau",
  "PA": "Panamá",
  "PG": "Papua Nova Guiné",
  "PY": "Paraguai",
  "NL": "Países Baixos",
  "BQ": "Países Baixos Caribenhos",
  "PE": "Peru",
  "PH": "Filipinas",
  "PL": "Polônia",
  "PF": "Polinésia Francesa",
  "PR": "Porto Rico",
  "PT": "Portugal",
  "QA": "Catar",
  "HK": "RAE de Hong Kong",
  "MO": "RAE de Macau",
  "CF": "República Centro-Africana",
  "DO": "República Dominicana",
  "RO": "Romênia",
  "GB": "Reino Unido",
  "RU": "Rússia",
  "RW": "Ruanda",
  "EH": "Saara Ocidental",
  "BL": "São Bartolomeu",
  "KN": "São Cristóvão e Nevis",
  "SM": "San Marino",
  "MF": "São Martinho",
  "SX": "São Martinho (parte holandesa)",
  "PM": "São Pedro e Miquelão",
  "VC": "São Vicente e Granadinas",
  "SH": "Santa Helena",
  "LC": "Santa Lúcia",
  "WS": "Samoa",
  "AS": "Samoa Americana",
  "ST": "São Tomé e Príncipe",
  "SN": "Senegal",
  "RS": "Sérvia",
  "SC": "Seicheles",
  "SL": "Serra Leoa",
  "SG": "Singapura",
  "SK": "Eslováquia",
  "SI": "Eslovênia",
  "SO": "Somália",
  "SD": "Sudão",
  "SS": "Sudão do Sul",
  "LK": "Sri Lanka",
  "SE": "Suécia",
  "CH": "Suíça",
  "SR": "Suriname",
  "SJ": "Svalbard e Jan Mayen",
  "SZ": "Suazilândia",
  "SY": "Síria",
  "TJ": "Tajiquistão",
  "TW": "Taiwan",
  "TZ": "Tanzânia",
  "TD": "Chade",
  "CZ": "Tchéquia",
  "TF": "Terras Austrais e Antárticas Francesas",
  "IO": "Território Britânico do Oceano Índico",
  "PS": "Territórios Palestinos",
  "TH": "Tailândia",
  "TL": "Timor-Leste",
  "TG": "Togo",
  "TK": "Toquelau",
  "TO": "Tonga",
  "TT": "Trinidad e Tobago",
  "TA": "Tristão da Cunha",
  "TN": "Tunísia",
  "TM": "Turcomenistão",
  "TR": "Turquia",
  "TV": "Tuvalu",
  "UA": "Ucrânia",
  "UY": "Uruguai",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Vietnã",
  "WF": "Wallis e Futuna",
  "YE": "Iémen",
  "ZM": "Zâmbia",
  "ZW": "Zimbábue"
}
